<div class="section">
  <div class="section__header">
    <h2 class="section__header-text">Webcams</h2>
    <button id="addWebcam"
            mat-mini-fab
            *ngIf="editModeSet"
            (click)="openEditWebcamDialog(null)">
      <mat-icon aria-label="Add Webcam">add</mat-icon>
    </button>
  </div>
  <div class="section__body">
    <table *ngIf="airport.webcams.length || hasFboWebcams(); else placeholder" class="data-block">
    <thead>
      <tr>
        <th class="data-block__label">Name:</th>
        <th class="data-block__label">Operated by:</th>
        <th class="data-block__label">Site:</th>
        <th class="data-block__label">Facing:</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let webcam of airport.webcams; let i = index" class="data-block__item">
        <td class="data-block__value">
          <mat-icon (click)="openEditWebcamDialog(i)" *ngIf="editModeSet" class="edit-icon" mat-tooltip="Edit" aria-label="Edit webcam">edit</mat-icon>
          <mat-icon (click)="deleteWebcam(i)" *ngIf="editModeSet" class="delete-icon" mat-tooltip="Delete" aria-label="Delete webcam">delete_outline</mat-icon>
          <a target="_blank" [href]="webcamUrl(webcam.url)">{{ webcam.name }}</a>
        </td>
        <td class="data-block__value" *ngIf="webcam.operatedBy; else operatedByPlaceholder">{{webcam.operatedBy}}</td>
        <td class="data-block__value">{{ webcam.site }}</td>
        <td class="data-block__value">{{ webcam.direction }}</td>
      </tr>
      <ng-container *ngFor="let business of airport.businesses">
        <tr *ngFor="let webcam of getFboWebcams(business)" class="data-block__item">
          <td class="data-block__value">
            <a target="_blank" [href]="webcamUrl(webcam.url)">{{ webcam.name }}</a>
          </td>
          <td class="data-block__value">{{ business.name }}</td>
          <td class="data-block__value">{{ webcam.site }}</td>
          <td class="data-block__value">{{ webcam.direction }}</td>
        </tr>
      </ng-container>
    </tbody>
  </table>
  </div>
  <div class="section__footer">
    <div class="airport-webcams__disclaimers">
      <em>Webcams are managed by their respective owners and may not always be available for viewing.</em>
    </div>
  </div>
  </div>

<ng-template #placeholder>
  <div class="detail-page__placeholder">
    <mat-icon class="detail-page__placeholder-icon">info</mat-icon>
    <div class="detail-page__placeholder-message">There are no webcams listed for {{airport.identifier.toUpperCase().startsWith('ZZ') ? 'this airport' : airport.identifier}}.  If you are
      aware of any webcams at or near the airport, please contact your airport manager or
      email <a href="mailto:airportdirectory@aopa.org">airportdirectory@aopa.org</a>.</div>
  </div>
</ng-template>

<ng-template #operatedByPlaceholder>
  <td class="data-block__value">Airport</td>
</ng-template>
